import React from 'react'
import Steps from '@/components/Steps'
import styled from 'styled-components'
import Newsletters from '@/components/Newsletters'

const Clean = ({
  newsletters,
  accentColor,
  btnColor,
  bgColor,
  foregroundColor,
  extra,
  steps = (
    <Steps
      newsletters={newsletters}
      btnColor={btnColor}
      accentColor={accentColor}
      reveal={<Newsletters newsletters={newsletters} />}
    />
  ),
}) => {
  return (
    <StHero
      className="p-1"
      style={{
        backgroundColor: bgColor ? bgColor : '#fff',
        color: foregroundColor ? foregroundColor : '#000',
      }}>
      <div className="space-y-2 content">
        <>{steps}</>
      </div>
    </StHero>
  )
}

const StHero = styled.div`
  position: relative;

  .content {
    position: relative;
    z-index: 2;
  }
`

export default Clean
